import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  ContainerStatus,
  Logo,
  Title,
  Subtitle,
  Video,
} from './styles';

const StudyStatus = (props) => {
  const {
    title,
    subtitle,
    screenRef,
  } = props;
  return (
    <Container>
      <ContainerStatus>
        <Logo src="/images/playbook-logo.png" alt="Playbook" />
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </ContainerStatus>
      <Video ref={screenRef} />
    </Container>
  );
};

StudyStatus.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  screenRef: PropTypes.oneOfType([
    PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    PropTypes.shape({ current: PropTypes.any }),
  ]).isRequired,
};

export default StudyStatus;
